/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const deleteProjectsProjectidPathProjectIdSchema = z.string()

export const deleteProjectsProjectidStatus204Schema = z.string()

export const deleteProjectsProjectidStatus400Schema = z.string()

export const deleteProjectsProjectidStatus401Schema = z.string()

export const deleteProjectsProjectidStatus404Schema = z.string()

export const deleteProjectsProjectidStatus500Schema = z.string()

export const deleteProjectsProjectidResponseSchema = deleteProjectsProjectidStatus204Schema

export const deleteProjectsProjectidErrorSchema = z.union([deleteProjectsProjectidStatus400Schema, deleteProjectsProjectidStatus401Schema, deleteProjectsProjectidStatus404Schema, deleteProjectsProjectidStatus500Schema])
